var e4 = e4 || {},
    dcc = dcc || {};
( function () {
    dcc.hubspot = {
        settings: {
            url: 'https://tools.web2media.dk/request/data/update',
            client: 'dcc',
            version: 1.2,
            log: function () {
                return localStorage.getItem( 'hubspot_logging' ) === 'true';
            }
        },
        init: function () {
            dcc.hubspot.bindEvents();
            if ( jQuery( '.js-dcc-hubspot-receipt-data' ).length === 1 ) {
                var objData = window.receiptHubspotData;
                if ( objData !== undefined ) {
                    dcc.hubspot.send( objData );
                }
            }
        },
        bindEvents: function () {
            jQuery( '.js-dcc-hubspot-form' ).on( 'click', 'button[type="submit"]', function ( event ) {
                event.preventDefault();
                if ( jQuery( event.target ).closest( 'form' ).valid() === true ) {
                    var formData = jQuery( event.target ).closest( 'form' ).serializeArray();
                    dcc.hubspot.events.userRequest( formData );
                }
            } );
            if ( jQuery( 'body' ).data( 'userauthenticated' ) === true && sessionStorage.getItem( 'e4.login.userauthenticated' ) === 'false' ) {
                dcc.hubspot.events.login();
            }
        },
        ajax: function ( objAjaxSettings, fnCallback ) {
            var jqXHR = jQuery.ajax( jQuery.extend( {
                url: dcc.hubspot.settings.url,
                method: 'POST',
                dataType: 'json',
                cache: false
            }, objAjaxSettings ) );
            jqXHR.done( function ( responds ) {
                if ( dcc.hubspot.settings.log() === true ) {
                    console.log( 'HubSpot responds: ', responds );
                }
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( responds );
                }
            } );
        },
        send: function ( objExtendData, fnCallback ) {
            var objData = {
                client: dcc.hubspot.settings.client,
                version: dcc.hubspot.settings.version
            };
            if ( jQuery.isPlainObject( objExtendData ) ) {
                jQuery.extend( objData, objExtendData );
            }
            if ( dcc.hubspot.settings.log() === true ) {
                console.group( 'Hubspot send' );
                console.log( 'Hubspot post data: ', objData );
            }
            /*
            dcc.hubspot.ajax( {
                data: objData
            }, function ( responds ) {
                if ( dcc.hubspot.settings.log() === true ) {
                    console.log( 'Hubspot post status: ', responds );
                }
                if ( responds.accept !== true ) {
                    console.error( 'Hubspot error. Error ID: ', responds.id );
                }
                else {
                    if ( typeof fnCallback === 'function' ) {
                        fnCallback( responds );
                    }
                }
                if ( dcc.hubspot.settings.log() === true ) {
                    console.groupEnd();
                }
            } );
            
             */
        },
        getOrderlines: function ( objCartData ) {
            var orderlines = [];
            objCartData.cart.orderlines.forEach( function ( objOrderline ) {
                orderlines.push( {
                    ean: '',
                    sku: objOrderline.product.id,
                    amount: objOrderline.quantity,
                    price: objOrderline.product.priceWithVat,
                    price_witout_vat: objOrderline.product.priceWithoutVat,
                    vat: objOrderline.product.vat,
                    discount: objOrderline.product.discount,
                    name: objOrderline.product.name
                } );
            } );
            return orderlines;
        },
        getFormField: function ( arrFormFields, key ) {
            var foundFormField = arrFormFields.filter( function ( formField ) {
                return formField.name === key;
            } );
            if ( foundFormField.length ) {
                return foundFormField[ 0 ].value;
            }
            return '';
        },
        getUserData: function () {
            var userData = null;
            if ( window.getUserData !== undefined ) {
                userData = window.getUserData();
            }
            return userData;
        },
        getSplitName: function ( strName ) {
            var strFullName = strName.split( ' ' ),
                strFirstName = strFullName[ 0 ],
                strLastName = strFullName[ strFullName.length - 1 ];
            return {
                firstname: strFirstName,
                lastname: strLastName
            };
        },
        events: {
            userRequest: function ( formData ) {
                /* -- HUBSPOT EVENT = userRequest -- tested ok */
                var objName = dcc.hubspot.getSplitName( dcc.hubspot.getFormField( formData, 'Name' ) ),
                    objData = {
                        formType: 'userRequest',
                        first_name: objName.firstname,
                        last_name: objName.lastname,
                        company_name: dcc.hubspot.getFormField( formData, 'CompanyName' ),
                        email: dcc.hubspot.getFormField( formData, 'Email' ),
                        phone: dcc.hubspot.getFormField( formData, 'Phone' ),
                        language: navigator.language,
                        country: dcc.hubspot.getFormField( formData, 'dealerCountry' )
                    };
                dcc.hubspot.send( objData, function () {
                    jQuery( '.js-dcc-hubspot-form' ).submit();
                } );
            },
            login: function () {
                /* -- HUBSPOT EVENT = login -- tested ok */
                var userData = dcc.hubspot.getUserData(),
                    objName = '',
                    objData = {};
                if ( userData !== null ) {
                    objName = dcc.hubspot.getSplitName( userData.name );
                    objData = {
                        formType: 'login',
                        first_name: objName.firstname,
                        last_name: objName.lastname,
                        company_name: userData.company,
                        email: userData.email,
                        language: userData.language,
                        dcc_contact_id: userData.dcc_contact_id,
                        dcc_customer_id: userData.dcc_customer_id
                    };
                }
                dcc.hubspot.send( objData );
            },
            newBasket: function ( objCartData ) {
                /* -- HUBSPOT EVENT = newBasket -- tested ok */
                var userData = dcc.hubspot.getUserData(),
                    objData = {
                        formType: 'newBasket',
                        email: userData !== null ? userData.email : '',
                        language: userData !== null ? userData.language : '',
                        dcc_contact_id: userData !== null ? userData.dcc_contact_id : '',
                        dcc_customer_id: userData !== null ? userData.dcc_customer_id : '',
                        order_id: objCartData.cart.id,
                        order_total: objCartData.cart.priceClean,
                        vat_total: objCartData.cart.priceVATClean,
                        number_of_items: objCartData.cart.productQuantity,
                        order_lines: dcc.hubspot.getOrderlines( objCartData )
                    };
                dcc.hubspot.send( objData );
            },
            updatedBasket: function ( objCartData ) {
                /* -- HUBSPOT EVENT = updatedBasket -- tested ok */
                var userData = dcc.hubspot.getUserData(),
                    objData = {
                        formType: 'updatedBasket',
                        email: userData !== null ? userData.email : '',
                        language: userData !== null ? userData.language : '',
                        dcc_contact_id: userData !== null ? userData.dcc_contact_id : '',
                        dcc_customer_id: userData !== null ? userData.dcc_customer_id : '',
                        order_id: objCartData.cart.id,
                        order_total: objCartData.cart.priceClean,
                        vat_total: objCartData.cart.priceVATClean,
                        number_of_items: objCartData.cart.productQuantity,
                        order_lines: dcc.hubspot.getOrderlines( objCartData )
                    };
                dcc.hubspot.send( objData );
            },
            checkoutStep: function ( stepData, objOrderData ) {
                /* -- HUBSPOT EVENT = checkoutStep -- tested ok */
                var intStepNumber = 0;
                if ( stepData === 'shipping' ) {
                    intStepNumber = 1;
                }
                else if ( stepData === 'customer' ) {
                    intStepNumber = 2;
                }
                else if ( stepData === 'approve' ) {
                    intStepNumber = 3;
                }
                if ( intStepNumber > 0 ) {
                    e4.cart.ajax( {
                        method: 'GET'
                    }, function ( data ) {
                        var objCartData = data,
                            userData = dcc.hubspot.getUserData(),
                            objName = dcc.hubspot.getSplitName( objOrderData.order.customer.name ),
                            objData = {
                                formType: 'checkoutStep' + intStepNumber,
                                email: objOrderData.order.customer.email,
                                language: objOrderData.order.customer.countryCode,
                                dcc_contact_id: userData !== null ? userData.dcc_contact_id : '',
                                dcc_customer_id: userData !== null ? userData.dcc_customer_id : '',
                                order_id: objCartData.cart.id,
                                order_total: objCartData.cart.priceClean,
                                vat_total: objCartData.cart.priceVATClean,
                                number_of_items: objCartData.cart.productQuantity,
                                order_lines: dcc.hubspot.getOrderlines( objCartData )
                            },
                            shippingMethod = objOrderData.order.shippingmethods.filter( function ( method ) {
                                return method.isSelected === true;
                            } )[ 0 ].id,
                            paymethod = objOrderData.order.paymethods.filter( function ( method ) {
                                return method.isSelected === true;
                            } )[ 0 ].id;
                        switch ( intStepNumber ) {
                            case 1: //Shipping
                                jQuery.extend( objData, {
                                    address_1: objOrderData.order.customer.address,
                                    address_2: objOrderData.order.customer.address2,
                                    delivery_Address: objOrderData.order.delivery.address,
                                    delivery_option: shippingMethod,
                                    zipcode: objOrderData.order.customer.zip,
                                    city: objOrderData.order.customer.city,
                                    country: objOrderData.order.customer.country
                                } );
                                break;
                            case 2: //Customer
                                jQuery.extend( objData, {
                                    first_name: objName.firstname,
                                    last_name: objName.lastname,
                                    address_1: objOrderData.order.customer.address,
                                    address_2: objOrderData.order.customer.address2,
                                    zipcode: objOrderData.order.customer.zip,
                                    city: objOrderData.order.customer.city,
                                    country: objOrderData.order.customer.country,
                                    phone: objOrderData.order.customer.phone,
                                    delivery_option: shippingMethod
                                } );
                                break;
                            case 3: //Approve
                                jQuery.extend( objData, {
                                    payment_option: paymethod,
                                    delivery_option: shippingMethod
                                } );
                                break;
                        }
                        dcc.hubspot.send( objData );
                    } );
                }
            }
        }
    };
}() );
